/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC, useEffect} from 'react'
import {Link} from 'react-router-dom'
import {Languages} from './Languages'
import { useAppDispatch, useAppSelector } from '../../../../app/modules/store/Store'
import { signOut } from '../../../../app/modules/auth/Auth.slice'
import { useIntl } from 'react-intl'
import { selectUser } from '../../../../app/modules/profile/Profile.slice'
import { selectOrganization } from '../../../../app/modules/organization/Organization.slice'

const HeaderUserMenu: FC = () => { 
  const intl = useIntl()
  const dispatch = useAppDispatch()
  const currentUser = useAppSelector(selectUser)
  const currentOrg = useAppSelector(selectOrganization)

  const logoutClickHandler = () => {
    dispatch(signOut())
    document.location.reload()
  }

  return (
  <>
    <div
    className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg menu-state-primary fw-bold py-4 fs-6 w-275px'
    data-kt-menu='true'
  >
    <div className='menu-item px-3'>
      <div className='menu-content d-flex align-items-center px-3'>
        <div className='d-flex flex-column'>
          <div className='fw-bolder d-flex align-items-center fs-5'>
            {currentUser?.displayName}
          </div>
          <div className='fw-bold text-muted fs-7'>{currentUser?.email}</div>
          <div className='fw-bold text-muted fs-7'>{currentOrg?.gui}</div>
          
        </div>
      </div>
    </div>

    {/* <div className='separator my-2'></div> */}

    {/* <div className='menu-item px-5'>
      <Link to={'/crafted/pages/profile'} className='menu-link px-5'>
        Mi Perfil
      </Link>
    </div>

    <div className='separator my-2'></div> */}

    {/* <Languages /> */}

    {/* <div className='menu-item px-5 my-1'>
      <Link to='/crafted/account/settings' className='menu-link px-5'>
        Ajustes
      </Link>
    </div> */}

    <div className='separator my-2'></div>

    <div className='menu-item px-5'>
      <a onClick={logoutClickHandler} className='menu-link px-5'>
        {intl.formatMessage({id: 'LOGOUT'})}
      </a>
    </div>
  </div>
  </>
  )
}
export {HeaderUserMenu}
